/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aria_Close_DialogInputs */

const en_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close dialog`)
};

const de_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog schliessen`)
};

const fr_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le dialogue`)
};

const es_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar dialogo`)
};

const it_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi finestra di dialogo`)
};

const nl_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialoog sluiten`)
};

const pl_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij okno dialogowe`)
};

const fi_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje dialogi`)
};

const da_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk dialog`)
};

const sv_aria_close_dialog = /** @type {(inputs: Aria_Close_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staeng dialog`)
};

/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Aria_Close_DialogInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const aria_close_dialog = /** @type {((inputs?: Aria_Close_DialogInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aria_Close_DialogInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_aria_close_dialog(inputs)
	if (locale === "fr") return fr_aria_close_dialog(inputs)
	if (locale === "es") return es_aria_close_dialog(inputs)
	if (locale === "it") return it_aria_close_dialog(inputs)
	if (locale === "nl") return nl_aria_close_dialog(inputs)
	if (locale === "pl") return pl_aria_close_dialog(inputs)
	if (locale === "fi") return fi_aria_close_dialog(inputs)
	if (locale === "da") return da_aria_close_dialog(inputs)
	if (locale === "sv") return sv_aria_close_dialog(inputs)
	return en_aria_close_dialog(inputs)
});